import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');

class TemplateCarouselBasicLast extends Component {

    constructor(props) {
        super(props);
        this.state = {
            price: "",
            error: false
        };
    };

    componentWillMount() {
        try {
            let url = window.location.search;
            let data = queryString.parse(url);
            this.setState({
                price: data.price
            }, () => {
                console.log(this.state.price)
            })
        }catch (e) {
            this.setState({
                error: true
            });
            console.log(e);
        }
    }

    render() {
        return(
            <div className={Styles.container}>
                <div className={Styles.containerTitle}>
                    {this.state.price}
                </div>
                <div className={Styles.containerSubtitle}>
                    {"Learn more"}
                </div>
            </div>
        )
    }
}

export default TemplateCarouselBasicLast;


// WEBPACK FOOTER //
// ./src/templates/carousel/basic/last/component.js